/** The categories an operator can pick when resolving a call. */
export const RESOLVE_CALL_OPTIONS = [
  "Emergency",
  "ER24 Dispatched",
  "Non-Medical Emergency",
  "Technical Issue",
  "Test Call",
  "Accidental Activation",
  "Low Battery?",
  "Technical Support",
  "Courtesy Call",
  "False Alarm",
  "Other",
] as const;

/** The value the API stores for a category, e.g. "Low Battery?" is LOW_BATTERY. */
export function toResolutionCategoryValue(category: string) {
  return category
    .trim()
    .toUpperCase()
    .replaceAll(/[^A-Z\d]+/g, " ")
    .trim()
    .replaceAll(" ", "_");
}

const LABEL_BY_VALUE = new Map<string, string>(
  RESOLVE_CALL_OPTIONS.map((label) => [toResolutionCategoryValue(label), label])
);

/** The label the operator picked, for a category the API returns. */
export function formatResolutionCategory(value?: string | null) {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return LABEL_BY_VALUE.get(toResolutionCategoryValue(trimmed)) ?? trimmed;
}

/** "Category: notes", or whichever of the two was recorded. */
export function formatCallResolution(
  category?: string | null,
  notes?: string | null
) {
  const label = formatResolutionCategory(category);
  const text = notes?.trim() || null;
  if (label && text) return `${label}: ${text}`;
  return label ?? text;
}
